///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { eulaFeatureKey, EulaState } from './eula.state';
import { PlannerEulaDTO } from '../../../generated/shared-types.model';

export const selectEulaState = createFeatureSelector<EulaState>(eulaFeatureKey);

export const selectEulaDate = createSelector(selectEulaState, (state: EulaState): Date | null => state.eula?.versionDate ?? null);

export const selectEula = createSelector(selectEulaState, (state: EulaState): PlannerEulaDTO => state.eula);
